import { useEffect, useState } from "react";

const REDUCED_TRANSPARENCY_QUERY = "(prefers-reduced-transparency: reduce)";

function prefersReducedTransparency(): boolean {
  return (
    typeof window !== "undefined" &&
    window.matchMedia?.(REDUCED_TRANSPARENCY_QUERY).matches === true
  );
}

/** The OS Reduce Transparency preference, followed while mounted. */
export function useReducedTransparency(): boolean {
  const [reduced, setReduced] = useState(prefersReducedTransparency);
  useEffect(() => {
    const query = window.matchMedia?.(REDUCED_TRANSPARENCY_QUERY);
    if (!query?.addEventListener) return;
    const update = () => setReduced(query.matches);
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  return reduced;
}
